/**
 * Admin authentication API endpoints.
 */

import { http } from './http';
import type { AdminSession, AdminUser } from './types';

/** POST /api/v1/admin/auth/login */
export async function loginAdmin(email: string, password: string): Promise<AdminSession> {
  return http.post<AdminSession>('/admin/auth/login', { email, password });
}

/** POST /api/v1/admin/auth/refresh */
export async function refreshAdminToken(
  refreshToken: string,
): Promise<{ accessToken: string; expiresAt: string }> {
  return http.post('/admin/auth/refresh', { refreshToken });
}

/** POST /api/v1/admin/auth/logout */
export async function logoutAdmin(): Promise<void> {
  await http.post('/admin/auth/logout');
}

/** GET /api/v1/admin/auth/me */
export async function getCurrentAdmin(): Promise<{ admin: AdminUser }> {
  return http.get('/admin/auth/me');
}
